import {
  Centrifuge,
  JoinContext,
  LeaveContext,
  PublicationContext,
} from 'centrifuge';

function subscribeToChannel(
  ws: Centrifuge,
  channelDetails: {
    channel_name: string;
    channel_token: string;
  },
  {
    onPublication,
    onJoin,
    onLeave,
  }: {
    onPublication: (ctx: PublicationContext) => void;
    onJoin?: (ctx: JoinContext) => void;
    onLeave?: (ctx: LeaveContext) => void;
  },
) {
  const sub = ws.newSubscription(channelDetails.channel_name, {
    token: channelDetails.channel_token,
  });

  // Example: Add event listeners for the subscription
  sub.on('publication', (ctx) => {
    console.log('Publication received:', ctx);
    onPublication(ctx);
  });

  sub.on('join', (ctx) => {
    console.log('User joined:', ctx);
    onJoin?.(ctx);
  });

  sub.on('leave', (ctx) => {
    console.log('User left:', ctx);
    onLeave?.(ctx);
  });

  // Connect the subscription and WebSocket
  sub.subscribe();
  ws.connect();

  return sub;
}

function initializeWebSocket(access_token: string): Centrifuge {
  const ws = new Centrifuge(import.meta.env.VITE_ZOOM_WS_URL, {
    token: access_token,
  });

  return ws;
}

export const callWs = {
  subscribeToChannel,
  initializeWebSocket,
};
